// Simulation
export enum ResultActionTypes {
  CLEAR_SIMULATION_RESULTS = "clear.simulation.results",
  ADD_WAVE_RESULT = "add.simulation.waves.result",
  START_WAVE_SIMULATION = "start.wave.simulation",
}
